module.exports = __webpack_public_path__ + "static/media/intro_mb.8287d2ee.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/Drone/intro_mb.mp4
// module id = 315
// module chunks = 0